<template>
  <div v-if="sessionTime" class="cso-session-timer">{{ sessionTime }}</div>
</template>

<script lang="ts">
import CsoRouter from '@/api/CsoRouter'
import Session from '@/common/Session'

export default {
  name: 'CsoSessionTimer',

  data() {
    return {
      sessionTime: '00:00',
      sessionInterval: 0
    }
  },

  methods: {
    updateSessionTime () {
      const time = Session.getRemainingTime()
      const seconds = (time % 60).toString().padStart(2, '0')
      const minutes = Math.floor(time / 60).toString().padStart(2, '0');
      this.sessionTime = CsoRouter.isOpenArea ? '' : `${minutes}:${seconds}`
    }
  },
  
  mounted () {
    this.sessionInterval = setInterval(() => this.updateSessionTime(), 1000) as unknown as number
    this.updateSessionTime()
  },

  unmounted () {
    clearInterval(this.sessionInterval)
  }
}
</script>

<style lang="scss">
.cso-session-timer {
  background-color: $gray-f2;
  width: 78px;
  line-height: 44px;
  border-radius: 22px;
  font-size: 15px;
  text-align: center;
  margin-left: 15px;
  color: $gray-4d;
}
</style>